import React from "react";

// Animated road ribbon with a driving vehicle.
// `reverse` flips the vehicle's travel direction (right-to-left) and its silhouette.
export default function RoadRibbon({ withCar = true, text = "", reverse = false, testid = "road-ribbon" }) {
  return (
    <div className={`road-ribbon relative ${reverse ? "reverse" : ""}`} data-testid={testid}>
      {text && (
        <div className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none px-3">
          <span className="text-white text-[11px] sm:text-xs font-bold tracking-widest uppercase whitespace-nowrap" style={{ textShadow: "0 1px 3px rgba(0,0,0,0.85), 0 0 8px rgba(30,28,25,0.9)" }}>
            {text}
          </span>
        </div>
      )}
      {withCar && (
        <svg className={`car-drive absolute top-1/2 ${reverse ? "car-drive-reverse" : ""}`} width="48" height="26" viewBox="0 0 46 24" fill="none" aria-hidden="true">
          <rect x="2" y="8" width="34" height="10" rx="2" fill="#f97316" />
          <rect x="8" y="3" width="22" height="8" rx="2" fill="#fbbf24" />
          <circle cx="10" cy="19" r="4" fill="#0f172a" /><circle cx="10" cy="19" r="1.5" fill="#94a3b8" />
          <circle cx="30" cy="19" r="4" fill="#0f172a" /><circle cx="30" cy="19" r="1.5" fill="#94a3b8" />
          <rect x="37" y="10" width="6" height="5" rx="1" fill="#fde68a" />
        </svg>
      )}
    </div>
  );
}
